import React, { ReactNode, useState } from 'react';
import { MealCategoryFormType, NewMealCategoryContext } from './context';

const NewMealCategoryProvider = ({ children }: { children: ReactNode }) => {
  const [formData, setFormData] = useState({} as MealCategoryFormType);

  return (
    <NewMealCategoryContext.Provider
      value={{
        formData,
        setFormData
      }}>
      {children}
    </NewMealCategoryContext.Provider>
  );
};

export default NewMealCategoryProvider;
